import { FC, InputHTMLAttributes, ReactNode } from 'react'

import {
  ChipCheckbox,
  ChipCheckmarkIcon,
  ChipLabel,
  ChipWrapper,
  CornerRibbon,
} from './styled'

export type SelectableIconChipLayout = 'horizontal' | 'vertical'

export type SelectableIconChipProps = InputHTMLAttributes<HTMLInputElement> & {
  /**
   * Unique identifier for the chip.
   * Accessibility requirement to connect the chip to its label
   */
  id: string
  /**
   * The icon for the chip
   */
  icon: ReactNode
  /**
   * The label for the chip
   */
  label: string | ReactNode
  /**
   * Layout direction for the elements in the chip - 'horizontal' or 'vertical'
   */
  layout?: SelectableIconChipLayout
}

export const SelectableIconChip: FC<SelectableIconChipProps> = ({
  checked,
  id,
  icon,
  label,
  layout = 'vertical',
  ...rest
}) => {
  return (
    <ChipWrapper data-testid="selectable-icon-chip">
      <ChipCheckbox type="checkbox" id={id} checked={checked} {...rest} />
      <ChipLabel htmlFor={id} layout={layout}>
        {icon}
        <span>{label}</span>
        {checked && (
          <CornerRibbon>
            <ChipCheckmarkIcon />
          </CornerRibbon>
        )}
      </ChipLabel>
    </ChipWrapper>
  )
}
